import axios from 'axios';
import CryptoJS from 'crypto-js';

const axisUsername = 'root';
const axisPassword = '809131uu';

const hanwhaUsername = 'admin';
const hanwhaPassword = 'Clinic24/';

const getAuthorizationHeader = async (url, method, body, username, password) => {
    // Initial request to get WWW-Authenticate header
    console.log(`Sending request to ${url} with method ${method} and body ${body} using username ${username} and password ${password}`);
    const initialResponse = await axios({
        method,
        url,
        validateStatus: (status) => status === 401, // Only accept 401 status
        data: body,
    });
    const authHeader = initialResponse.headers['www-authenticate'];
    if (!authHeader) {
        throw new Error('WWW-Authenticate header not found');
    }

    const authParams = parseDigestAuthHeader(authHeader);
    const response = calculateDigestResponse(authParams, url, method, username, password);
    return response;
}

const digestHanwhaAuthRequest = async (url, method = 'GET', body = null) => {
    try {
        console.log("Getting auth headers for hanwha auth request")
        const response = await getAuthorizationHeader(url, method, body, hanwhaUsername, hanwhaPassword)

        const finalResponse = await axios({
            method,
            url,
            headers: {
                Authorization: response,
            },
            data: body,
        });

        return finalResponse.data;
    } catch (error) {
        console.error('Digest authentication failed', error);
        throw error;
    }
};

const digestAuthRequest = async (url, method = 'GET', body = null) => {
    try {
        const response = await getAuthorizationHeader(url, method, body, axisUsername, axisPassword)

        const finalResponse = await axios({
            method,
            url,
            headers: {
                Authorization: response,
            },
            data: body,
        });

        return finalResponse.data;
    } catch (error) {
        console.error('Digest authentication failed', error);
        throw error;
    }
};

export const fetchCameraStream = async (url) => {
    try {
        const authHeader = await getAuthorizationHeader(url, 'GET', null, axisUsername, axisPassword);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': authHeader,
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);

        return objectURL;
        // const imgElement = document.getElementById('cameraStream');
        // imgElement.src = objectURL;
    } catch (error) {
        console.error('There has been a problem with your fetch operation:', error);
    }
}

const parseDigestAuthHeader = (header) => {
    const prefix = 'Digest ';
    const auth = header.substring(prefix.length);
    const parts = auth.split(', ').reduce((acc, part) => {
        const match = part.match(/(\w+)=["]?([^"]+)["]?/);
        if (match) {
            acc[match[1]] = match[2];
        }
        return acc;
    }, {});

    return parts;
};

const calculateDigestResponse = (authParams, url, method, username, password) => {
    const { realm, nonce, qop, opaque, algorithm = 'MD5' } = authParams;
    // remove the http://carex from the uri
    const uri = url.startsWith('https://carex-axis') ? url.replace('https://carex-axis.mshome.net', '') : url.replace('https://hanwha-axis.mshome.net' , '');
    const nc = '00000001';
    const cnonce = CryptoJS.lib.WordArray.random(8).toString();

    const ha1 = CryptoJS.MD5(`${username}:${realm}:${password}`).toString();
    const ha2 = CryptoJS.MD5(`${method}:${uri}`).toString();
    const response = CryptoJS.MD5(`${ha1}:${nonce}:${nc}:${cnonce}:${qop}:${ha2}`).toString();

    return `Digest username="${username}", realm="${realm}", nonce="${nonce}", uri="${uri}", qop=${qop}, nc=${nc}, cnonce="${cnonce}", algorithm=${algorithm}, response="${response}"`;
};

export { digestAuthRequest, digestHanwhaAuthRequest };